import { supabase } from '../lib/supabase';

// Base URL for Supabase storage
const STORAGE_BASE_URL = 'https://images.vmon.vn/storage/v1/object/public/vmon';

// Function to get the Supabase storage URL for an image
export const getStorageUrl = (path: string): string => {
  return `${STORAGE_BASE_URL}/${path}`;
};

// Function to update image URL to use Supabase storage
export const updateImageUrl = (originalUrl: string): string => {
  // If it's already a Supabase URL, return it as is
  if (originalUrl.includes('images.vmon.vn')) {
    return originalUrl;
  }

  // Handle different image types
  if (originalUrl.startsWith('/feedback/')) {
    const fileName = originalUrl.split('/').pop();
    return getStorageUrl(`feedback/${fileName}`);
  }
  
  if (originalUrl.startsWith('/flag/')) {
    const fileName = originalUrl.split('/').pop();
    return getStorageUrl(`flag/${fileName}`);
  }
  
  if (originalUrl.startsWith('/panel/')) {
    const fileName = originalUrl.split('/').pop();
    return getStorageUrl(`panel/${fileName}`);
  }
  
  // Handle root level files
  if (originalUrl.startsWith('/') && !originalUrl.includes('/')) {
    return getStorageUrl(originalUrl.substring(1));
  }
  
  // For external images (like Pexels), keep them as is
  if (originalUrl.startsWith('http')) {
    return originalUrl;
  }
  
  // Default case - just append to storage URL
  const path = originalUrl.startsWith('/') ? originalUrl.substring(1) : originalUrl;
  return getStorageUrl(path);
};